export default "__VITE_ASSET__Lq0tM922__"